import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { averageScore } from '../planningQuality'

import {
  getCockpitInitiativesPlanQuality,
  type IGetCockpitInitiativesPlanQualityParams,
} from './getCockpitInitiativesPlanQuality'
import type { TCockpitInitiativesQuality } from './getCockpitInitiativesQuality'

export interface ICockpitInitiativesPlanQualitySummary {
  byOffering: ReadonlyMap<string, TCockpitInitiativesQuality>
  overallQuality: TCockpitInitiativesQuality
  averageOfferingScore: number | null
}

interface IParams extends Omit<IGetCockpitInitiativesPlanQualityParams, 'offering'> {
  offeringPresentation: Array<{ offering: string }>
}

export const getCockpitInitiativesPlanQualitySummary = ({
  offeringPresentation,
  ...params
}: IParams): ICockpitInitiativesPlanQualitySummary => {
  const byOffering = new Map(
    offeringPresentation.map(
      ({ offering }) =>
        [offering, getCockpitInitiativesPlanQuality({ ...params, offering })] as const
    )
  )

  return {
    byOffering,
    overallQuality: getCockpitInitiativesPlanQuality({
      ...params,
      offering: ProgramTypes.Overall,
    }),
    averageOfferingScore: averageScore(
      Array.from(byOffering.values(), ({ overall }) => overall.score)
    ),
  }
}
